module.exports = __webpack_public_path__ + "static/media/sunrise.d7d3d5db.svg";